import { Button } from "@fluentui/react-components";
import { OpenRegular } from "@fluentui/react-icons";

export const SettingsUserProfile = () => (
  <ul className="flex w-full flex-col space-y-6">
    <li className="flex items-center justify-between">
      <span className="text-sm font-medium">Avatar picture</span>
      <Button
        appearance="transparent"
        as="a"
        href="https://myaccount.microsoft.com/"
        icon={<OpenRegular />}
        rel="noopener noreferrer"
        target="_blank"
      >
        Update picture
      </Button>
    </li>
  </ul>
);
